import { advantages } from "@/mocks/home";

export default function Advantages() {
  return (
    <section className="py-20 md:py-28 bg-background-100/60 border-y border-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-4">
            <span className="text-xs uppercase tracking-widest text-accent-700 font-semibold">Why Voxmaster</span>
            <h2 className="mt-3 text-3xl md:text-5xl font-semibold text-foreground-950 leading-tight">
              Built by operators, for operators.
            </h2>
            <p className="mt-5 text-foreground-700 leading-relaxed">
              Every process in the platform — from routing to invoicing — was designed by people who ran carrier networks and got tired of the alternatives. That&apos;s why the small details actually work.
            </p>
            <div className="mt-8 rounded-xl border border-background-200 bg-background-50 p-5">
              <div className="flex items-center gap-3">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20headshot%20portrait%20of%20a%20confident%20telecommunications%20engineer%20in%20his%20forties%20smiling%20naturally%2C%20soft%20studio%20lighting%20with%20clean%20neutral%20light%20gray%20background%2C%20wearing%20a%20simple%20navy%20blazer%2C%20editorial%20photography%2C%20high%20detail%2C%20warm%20natural%20color%20grade&width=96&height=96&seq=vx-cto-avatar-01&orientation=squarish"
                  alt="Chief Network Officer"
                  className="w-12 h-12 rounded-full object-cover object-top"
                />
                <div>
                  <p className="text-sm font-semibold text-foreground-950">Arthur M.</p>
                  <p className="text-xs text-foreground-600">Chief Network Officer, Voxmaster</p>
                </div>
              </div>
              <p className="mt-4 text-sm text-foreground-700 leading-relaxed">
                &ldquo;We measure our own routes hourly against public LCR feeds. If a partner beats us on quality for a destination, we swap — no politics, no ego.&rdquo;
              </p>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              {advantages.map((a) => (
                <div
                  key={a.title}
                  className="rounded-xl bg-background-50 border border-background-200 p-5 hover:border-accent-400 transition-colors"
                >
                  <span className="w-11 h-11 rounded-lg bg-accent-100 text-accent-700 flex items-center justify-center">
                    <i className={`${a.icon} text-xl w-6 h-6 flex items-center justify-center`} />
                  </span>
                  <h3 className="mt-4 text-base font-semibold text-foreground-950 font-heading">{a.title}</h3>
                  <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">{a.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}